module.exports = __webpack_public_path__ + "static/media/Survey2PurposePrinciplesPlayerSurvey.d6fe5260.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video-champion-101/Survey2PurposePrinciplesPlayerSurvey.mp4
// module id = 7009
// module chunks = 2